import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { useMessage } from "hooks/intl";
import { SegmentFEFields, SegmentTypes } from "types/segments";
import { links } from "utilities/links";
import { SegmentForm } from "./SegmentForm";
import { useStyles } from "./SegmentForm.styles";

export function AddSegment() {
  const classes = useStyles();
  const { message } = useMessage();

  const initialValues: SegmentFEFields = {
    type: SegmentTypes.DYNAMIC,
    active: false,
    description: "",
    name: "",
    parts: [],
  };

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "segments" }),
      path: links.segmentsList,
    },
  };

  return (
    <>
      <TopHeader
        title={message({ id: "addSegment" })}
        clearLink={links.segmentsList}
        breadcrumbs={breadcrumbs}
      />
      <div className={classes.formContainer}>
        <SegmentForm initialValues={initialValues} />
      </div>
    </>
  );
}
